import React, {useEffect, useState} from 'react'

import PropTypes from 'prop-types'
import Fade from "@material-ui/core/Fade";
import Loader from "../base-components/loader";


const StepsLoader = ({children, loading, masterLoader, loadingMessage}) => {
    const [endLoading, setEndLoading] = useState(false)

    useEffect(()=> {
        setEndLoading(true)

        return function cleanup() {
            setEndLoading(false)
        };
    }, [])


    return loading ? (
            <Fade in={endLoading} timeout={{ enter: 300, exit: 1200}} >
                <div className={masterLoader ? "step-loader master-loader" : "step-loader"}>
                <Loader />
                {loadingMessage && <p className="loading-mesasge">{ loadingMessage}</p>}
                </div>
            </Fade>
    ) : (
        <Fade in={endLoading} timeout={{ enter: 300, exit: 1200}} >
            <div className={"step-loader"}>
                {children}
            </div>
        </Fade>
    )
}

StepsLoader.propTypes = {
    children: PropTypes.any,
    loading: PropTypes.bool,
}



export default StepsLoader